import { useInView } from "../hooks/useInView";

const partners = [
  { src: "/images/partners/us-bank.png", alt: "US Bank", height: "h-16" },
  { src: "/images/partners/st-thomas.png", alt: "University of St. Thomas", height: "h-22" },
];

export function DemoCTA() {
  const [ref, inView] = useInView();

  return (
    <section id="demo" className="relative py-24 bg-bg-deep">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`text-center ${inView ? "animate-fade-up" : "start-hidden"}`}
        >
          <p className="text-brand-indigo font-semibold tracking-wide uppercase text-sm mb-3">
            For Institutions &amp; Employers
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Bring Dough to your{" "}
            <span className="text-brand-indigo">campus or company</span>
          </h2>
          <p className="text-text-secondary text-lg max-w-2xl mx-auto mb-10">
            Run a financial wellness program with competitions, prize drawings,
            and real engagement data. We&rsquo;ll help you get set up.
          </p>

          {/* Partner logos — hidden for now */}
          {/*
          <p className="text-text-tertiary/60 text-xs font-medium tracking-widest uppercase mb-5">
            Used by
          </p>
          <div className="flex items-center justify-center gap-16 mb-10">
            {partners.map((partner) => (
              <img
                key={partner.alt}
                src={partner.src}
                alt={partner.alt}
                className={`${partner.height} w-auto object-contain brightness-0 invert opacity-30 hover:opacity-60 transition-opacity duration-300`}
              />
            ))}
          </div>
          */}

          <a
            href="mailto:sales@dough-app.ai"
            className="inline-flex items-center gap-2 bg-brand-indigo hover:bg-brand-indigo/90 text-white font-semibold text-base px-8 py-4 rounded-xl transition-colors"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-5 h-5"
            >
              <path d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
            </svg>
            Contact Sales
          </a>
          <p className="mt-4 text-text-tertiary text-sm">
            sales@dough-app.ai
          </p>
        </div>
      </div>
    </section>
  );
}
